/** @format */
import {VariantType} from 'components/SensorGroupBar/model/types';

const getColorScheme = (isCritical: boolean, isRegular: boolean): VariantType => {
  if (isCritical) return 'red';
  if (isRegular) return 'yellow';
  return 'default';
};

export {getColorScheme};
